import { defineMessages } from 'react-intl';

export default defineMessages({
  shop_no_preOrder_label: {
    id: 'app.modules.shopDetails.ShopHeader.shop_no_preOrder_label',
    defaultMessage: 'No es posible realizar pedidos',
  },
  shop_preOrder_label: {
    id: 'app.modules.shopDetails.ShopHeader.shop_preOrder_label',
    defaultMessage: '¡Podés pre-pedir!',
  },
  shop_discount_label: {
    id: 'app.modules.shopDetails.ShopHeader.shop_discount_label',
    defaultMessage: 'Válido en algunos productos',
  },

  shop_discount: {
    id: 'app.modules.shopDetails.ShopHeader.card.shop_discount',
    defaultMessage: '{discount}% de descuento',
  },
  shop_opens_in: {
    id: 'app.modules.shopDetails.ShopHeader.shop_opens_in',
    defaultMessage: 'Abre a las ',
  },
  shop_is_closed: {
    id: 'app.modules.shopDetails.ShopHeader.shop_is_closed',
    defaultMessage: 'Cerrado por hoy',
  },
  shop_is_closed_reason: {
    id: 'app.modules.shopDetails.ShopHeader.shop_is_closed_reason',
    defaultMessage: 'Sin delivery momentáneamente',
  },
});
